
import Header from '../components/Header'
import Breadcrumb from "../components/Breadcrumb";
import Footer from '../components/Footer';
const Principalmessage = () => {
    return (
        <>
            <Header />
            <Breadcrumb pageTitle="Principal's Message" mid="About" breadcrumbName="Principal's Message" />
            <div className="inner-page">
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-5 col-md-6 col-dm-12'>
                            <img src="/Images/principal.jpg" className='img-fluid' />
                        </div>
                        <div className='col-lg-7 col-md-6 col-dm-12'>
                            <p><span>Dear Students,</span></p>
                            <p>Its my great pleasure to welcome you our school website . It is a platform for us to present our institution before you. I am very much delighted to see the progress of St Thomas Sr. sec. School through the commitment and dedication of the staff, cooperation of the parents, willingness and readiness of the students in forming the future citizens. We celebrate the academic, cultural, sporting and other achievements of our students together with satisfaction.</p>
                            <p>Our vision is to form qualified citizens for the nation so that they can shoulder greater responsibilities in various fields of development of the nation. A wholesome personality with good character, love for humanity and a dedicated heart to serve others, will make it possible. Our school community to move forward with the vision and mission having confidence and enthusiasm.</p>
                             
                            <p><span>Fr. Binoy Joseph</span><br /><b>Principal</b></p> 
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default Principalmessage